import React from "react";

export default ({ data }) => {
  return (
    <React.Fragment>
      <section id="portfolio-detail-description">
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Category</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <h5>{data.category}</h5>
          </div>
        </div>

        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Mode</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <h5>{data.mode}</h5>
          </div>
        </div>
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Features</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            {data.features &&
              data.features.map((item) => {
                return <p>{item}</p>;
              })}
          </div>
        </div>
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Tools</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <p>
              <b>Library/Framework/Engine: </b>
              {data.tools.core? data.tools.core : "N/A"}
            </p>
            <p>
              <b>Programming Language: </b>
              {data.tools.programming? data.tools.programming : "N/A"}
            </p>
            <p>
              <b>Database: </b>
              {data.tools.database? data.tools.database : "N/A"}
            </p>
          </div>
        </div>

        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Website</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            {data.website ? (
              <p>
                <a href={`${data.website}`} target="_blank">
                  Application
                </a>
              </p>
            ) : (
              "N/A"
            )}
          </div>
        </div>
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Github</span>
            </h1>
          </div>
          <div className="nine columns main-col">
            {data.githubLink ? (
              <p>
                <a href={`${data.githubLink}`} target="_blank">
                  Project Github
                </a>
              </p>
            ) : (
              "N/A"
            )}
          </div>
        </div>

        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Video Demo</span>
            </h1>
          </div>
          <div className="nine columns main-col">
            {data.demoLink ? (
              <iframe
                src={data.demoLink}
                width="640"
                height="480"
                allow="autoplay"
              ></iframe>
            ) : (
              "N/A"
            )}
          </div>
        </div>

        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Credits</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            {data.credits &&
              data.credits.map((item) => {
                return (
                  <p>
                    {item.sourceLink ? (
                      <a href={item.sourceLink} target="_blank">
                        {item.displayName}
                      </a>
                    ) : (
                      item.displayName
                    )}
                  </p>
                );
              })}
            {data.credits.length == 0 && "N/A"}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
